import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "@/App.css";
import PasswordGate from "@/components/PasswordGate";
import DealRoom from "@/DealRoom";

// Password-gated experience (default site).
function GatedApp() {
    const [authed, setAuthed] = useState(false);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("heir_access_token")) {
            setAuthed(true);
        }
        setChecked(true);
    }, []);

    if (!checked) return <div className="min-h-screen bg-navy-950" />;

    return (
        <AnimatePresence mode="wait">
            {authed ? (
                <motion.div
                    key="dealroom"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.8 }}
                >
                    <DealRoom />
                </motion.div>
            ) : (
                <motion.div
                    key="gate"
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <PasswordGate onUnlock={() => setAuthed(true)} />
                </motion.div>
            )}
        </AnimatePresence>
    );
}

// Public, non-indexed mirror of the pitch (no password).
function PublicPitch() {
    useEffect(() => {
        const meta = document.createElement("meta");
        meta.name = "robots";
        meta.content = "noindex, nofollow, noarchive";
        document.head.appendChild(meta);
        return () => {
            document.head.removeChild(meta);
        };
    }, []);

    return <DealRoom />;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/showmethepitch" element={<PublicPitch />} />
                    <Route path="*" element={<GatedApp />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
